import { TypeProduct, TypeProductFields } from '@/core/generated-types';
import { decodeProductId } from '@/utils/helpers';
import { shopifyProductField } from '@/core/contentfulConfig';
import {
  getShopifyDomain,
  YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS,
} from '@/core/constants';

export function getShopifyProductId(
  product: TypeProduct,
  shouldUsePlayKitId?: boolean,
) {
  let productIdKey = null;

  if (!product) return null;

  if (product.fields?.isPlayKit && !shouldUsePlayKitId) {
    return YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS[getShopifyDomain()];
  }

  productIdKey = shopifyProductField() as keyof TypeProductFields;

  const productId = product.fields[productIdKey] as string | undefined;

  if (!productId) return null;

  return decodeProductId(productId);
}
